import React, { useState, useEffect, useRef } from "react";
import "../insta-modal/insta-modal.css";


const MESES = [
  "Janeiro", "Fevereiro", "Março", "Abril",
  "Maio", "Junho", "Julho", "Agosto",
  "Setembro", "Outubro", "Novembro", "Dezembro",
];

const ANOS = Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - i);

const camposAudiencia = [
  { name: "seguidores",      label: "Seguidores",     icon: "bi-people-fill" },
  { name: "seguindo",        label: "Seguindo",       icon: "bi-person-plus-fill" },
  { name: "alcanceOrganico", label: "Alcance Orgânico", icon: "bi-broadcast" },
];

const camposConteudo = [
  { name: "reels",     label: "Reels",     icon: "bi-play-circle-fill" },
  { name: "postagens", label: "Postagens", icon: "bi-grid-3x3-gap-fill" },
  { name: "stories",   label: "Stories",   icon: "bi-camera-reels-fill" },
];

const camposEngajamento = [
  { name: "visualizacoes",      label: "Visualizações",    icon: "bi-eye-fill" },
  { name: "curtidas",           label: "Curtidas",         icon: "bi-heart-fill" },
  { name: "comentarios",        label: "Comentários",      icon: "bi-chat-dots-fill" },
  { name: "compartilhamentos",  label: "Compartilhamentos",icon: "bi-share-fill" },
  { name: "salvamentos",        label: "Salvamentos",      icon: "bi-bookmark-fill" },
];

const emptyForm = () => ({
  seguidores: "", seguindo: "", alcanceOrganico: "",
  reels: "", postagens: "", stories: "",
  visualizacoes: "", curtidas: "", comentarios: "",
  compartilhamentos: "", salvamentos: "",
  observacoes: "",
});

// ─── Campo numérico ───────────────────────────────────────────
function NumField({ name, label, icon, value, onChange }) {
  return (
    <div className="im-field">
      <label className="im-label">
        <i className={`bi ${icon}`}></i> {label}
      </label>
      <input
        type="number"
        min="0"
        className="im-input"
        name={name}
        value={value}
        onChange={onChange}
        placeholder="0"
      />
    </div>
  );
}

// ─── Seção com título ─────────────────────────────────────────
function Section({ label, color, children }) {
  return (
    <div className="im-section">
      <div className={`im-section-title im-section-title--${color}`}>
        {label}
      </div>
      <div className="im-section-body">{children}</div>
    </div>
  );
}

// ─── Modal principal ──────────────────────────────────────────
export default function InstaModal({
  show = true,
  nomeFranquia = "",   // virá da API
  onClose,
}) {
  const now = new Date();
  const [mes, setMes]   = useState(now.getMonth());      // 0-based
  const [ano, setAno]   = useState(now.getFullYear());
  const [form, setForm] = useState(emptyForm());
  const [dirty, setDirty]     = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (show) {
      setForm(emptyForm());
      setDirty(false);
      setShowConfirm(false);
    }
  }, [show]);

  if (!show) return null;

  const handle = (e) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
    setDirty(true);
  };

  // Fechar: se tiver dado não salvo, pede confirmação
  const handleClose = () => {
    if (dirty) setShowConfirm(true);
    else onClose?.();
  };

 const handleSave = () => {
    // 1. Prepara os dados (exatamente como você quer enviar)
    const dados = { 
        nomeFranquia,              // Valor do estado local (ou props, dependendo de onde estão)
        mes: MESES[mes],           // Mapeia "Abril", "Maio", etc.
        ano: Number(ano),          // Garante que é número no MySQL
        ...form                    // Espalha todos os campos do form (reels, curtidas, etc.)
    };

    console.log("=== Dados prontos para enviar:", dados);

    // 2. Chama a função onSave PASSANDO OS DADOS DIRETAMENTE.
    // Não precisa de variável intermediária nem opcional aqui.
    // A função que você definiu no seu pai (dentro das <> da tag) vai receber o 'dados'.
    
      //setDirty(false);
    //onClose(); // Fechar modal
};

  // Impede fechar clicando fora — só o X fecha
  const handleBackdropClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="im-backdrop" onClick={handleBackdropClick}>
      <div className="im-modal" role="dialog" aria-modal="true">

        {/* ── Header ── */}
        <div className="im-header">
          <div className="im-header-left">
            <div className="im-insta-icon">
              <i className="bi bi-instagram"></i>
            </div>
            <span className="im-franquia-nome">{nomeFranquia}</span>
          </div>

          <div className="im-header-right">
            {/* Seletor Mês/Ano */}
            <div className="im-period-group">
              <select
                className="im-select"
                value={mes}
                onChange={(e) => { setMes(Number(e.target.value)); setDirty(true); }}
              >
                {MESES.map((m, i) => (
                  <option key={m} value={i}>{m}</option>
                ))}
              </select>
              <select
                className="im-select im-select--year"
                value={ano}
                onChange={(e) => { setAno(Number(e.target.value)); setDirty(true); }}
              >
                {ANOS.map((a) => (
                  <option key={a} value={a}>{a}</option>
                ))}
              </select>
            </div>

            <button className="im-close-btn" onClick={handleClose} title="Fechar">
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>

        {/* ── Body com scroll ── */}
        <div className="im-body" ref={bodyRef}>

          {/* AUDIÊNCIA */}
          <Section label="Audiência" color="pink">
            <div className="im-grid im-grid--3">
              {camposAudiencia.map((c) => (
                <NumField key={c.name} {...c} value={form[c.name]} onChange={handle} />
              ))}
            </div>
          </Section>

          {/* CONTEÚDO */}
          <Section label="Conteúdo Publicado (mês)" color="pink">
            <div className="im-grid im-grid--3">
              {camposConteudo.map((c) => (
                <NumField key={c.name} {...c} value={form[c.name]} onChange={handle} />
              ))}
            </div>
          </Section>

          {/* ENGAJAMENTO */}
          <Section label="Engajamento" color="pink">
            <div className="im-grid im-grid--3">
              {camposEngajamento.map((c) => (
                <NumField key={c.name} {...c} value={form[c.name]} onChange={handle} />
              ))}
            </div>
          </Section>

          {/* OBSERVAÇÕES */}
          <div className="im-obs-wrap">
            <label className="im-obs-label">Observações:</label>
            <textarea
              className="im-textarea"
              name="observacoes"
              value={form.observacoes}
              onChange={handle}
              rows={4}
              placeholder="Anote aqui qualquer observação sobre esta franquia neste período..."
            />
          </div>
        </div>

        {/* ── Footer ── */}
        <div className="im-footer">
          <button className="im-btn im-btn--cancel" onClick={handleClose}>
            Cancelar
          </button>
          <button className="im-btn im-btn--save" onClick={handleSave}>
            <i className="bi bi-check-lg me-1"></i>
            Incluir Dados
          </button>
        </div>
      </div>

      {/* ── Confirm dialog (dados não salvos) ── */}
      {showConfirm && (
        <div className="im-confirm-overlay">
          <div className="im-confirm">
            <div className="im-confirm-icon">
              <i className="bi bi-exclamation-triangle-fill"></i>
            </div>
            <p className="im-confirm-text">
              Existem <strong>alterações não salvas</strong>.<br />
              Deseja sair mesmo assim?
            </p>
            <div className="im-confirm-actions">
              <button
                className="im-btn im-btn--cancel"
                onClick={() => setShowConfirm(false)}
              >
                Voltar
              </button>
              <button
                className="im-btn im-btn--danger"
                onClick={() => { setShowConfirm(false); onClose?.(); }}
              >
                Sair sem salvar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}